import TextBlur from './TextBlur'

export default TextBlur
